import {UserService} from '../../../../shared/services/user.service';
import {Customer} from '../../../../shared/models/customer';
import {ImageService} from '../../../../shared/services/image.service';
import {ArticleService} from '../../../../shared/services/article.service';
import {Article} from '../../../../shared/models/article';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {ProductsService} from '../../../../shared/services/products.service';
import {CartService} from '../../../../shared/services/cart.service';

declare var swal: any;

@Component({
  selector: 'app-product-left-sidebar',
  templateUrl: './product-left-sidebar.component.html',
  styleUrls: ['./product-left-sidebar.component.scss'],
})
export class ProductLeftSidebarComponent implements OnInit {

  constructor(
    public productsService: ProductsService,
    private _articleService: ArticleService,
    private _route: ActivatedRoute,
    private cartService: CartService,
    private uploadService: ImageService,
    private userService: UserService) {
  }

  public counter = 1;
  public selectedSize: any = '';
  public product: Article;
  public dolar: number;

  public slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
  };

  public slideNavConfig = {
    vertical: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.product-slick',
    arrows: false,
    dots: false,
    focusOnSelect: true
  };

  ngOnInit() {
    this.getArticle();
  }

  public addToCart(product: Article, quantity: number) {
    if (quantity <= 0) return false;
    this.cartService.addToCart(product, quantity);
  }

  getArticle() {
    this._route.params.forEach((params: Params) => {
      const id = params['id'];
      this._articleService.getArticle(id, null).subscribe(
        response => {
          this.product = {...response};
        },
        error => {
          if (error.status === 0) {
            swal({
              title: 'Error',
              text: 'Error en la llamada al servidor',
              icon: 'error',
              button: 'cerrar',
            });
          }
        }
      );
    }).then();
  }


  getPhotosArray(photos: string) {
    return this.uploadService.parsePhotoArray(photos);
  }

  geturl(image: string) {
    return this.uploadService.makeUrl(image);
  }

  getPrice(p: Article) {
    const customer: Customer = this.userService.getIdentity();
    if (customer) {
      return this._articleService.getPrice(p, customer.listPrice);
    } else {
      return p.unitPrice;
    }
  }

  validatePrice(p: Article) {
    return this.getPrice(p) > 0;
  }
}
